import { AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Icon from "../../common/icon/icon.component.jsx";
import RecurringOptionsDropdown from "../../common/recurring-options-dropdown/RecurringOptionsDropdown";
import LoadingSpinner from "../../common/spinner/loading.component.jsx";
import { GlobalHelper } from "../../indexImports.js";
import { PAYMENT_TYPE } from "../../state/helpers/Payment";
import { PROPOSAL_TYPE } from "../../state/proposal/ProposalType";
import PaymentMethodLabel from "./PaymentMethodLabel";
const uuidv4 = require('uuid/v4')

class RecurringInvoiceOptions extends Component {

    constructor(props, context) {
        super(props, context)
        const info = this.props.value || {}
        const attr = info.attributes || {}

        this.state = {
            info: info,
            capturePayment: attr.capturePayment || false,
            sendEmail: attr.sendEmail || false,
            createDaysInAdvance: attr.createDaysInAdvance || 0,
            invoiceId: this.props.invoiceId || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            endDateFocused: false,
            startDateFocused: false,
            contact: this.props.contact || null,
            contactId: this.props.contactId || '',
            modal: '',
            defaultCreditCard: undefined,
            defaultBankAccount: undefined,
            isCardLoading: true,
            refreshInvoice: this.props.refreshInvoice || function () { },
            hasIntegratedPayment: AppContext.hasFeatureIntegration(Features.IntegratedPayment),
            paymentMethod: attr.paymentMethod || '',
            saving: false,
            showAddPaymentMethodModal: false
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.handleUpdateOptions = this.handleUpdateOptions.bind(this)
        this.handleOpenModal = this.handleOpenModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.handleSubmitModal = this.handleSubmitModal.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const info = nextProps.value || {}
        const attr = info.attributes || {}
        const documentLocationId = nextProps.locationId

        const defaultCreditCard = GlobalHelper.getCardOnFilePerIntegrationLocation(documentLocationId, this.props.contact)
        const defaultBankAccount = GlobalHelper.getBankAccountOnFilePerIntegrationLocation(documentLocationId, this.props.contact)

        this.setState({
            info: info,
            capturePayment: attr.capturePayment || false,
            sendEmail: attr.sendEmail || false,
            createDaysInAdvance: attr.createDaysInAdvance || 0,
            invoiceId: nextProps.invoiceId || null,
            contact: nextProps.contact || null,
            contactId: nextProps.contactId || '',
            defaultCreditCard,
            defaultBankAccount,
            paymentMethod: attr.paymentMethod || '',
            isCardLoading: false,
        })
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.modal ? !this.state.editMode : false,
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({ saving: true })
        let data = {
            createDaysInAdvance: parseInt(this.state.createDaysInAdvance),
            capturePayment: this.state.capturePayment,
            sendEmail: this.state.sendEmail,
            paymentMethod: this.state.paymentMethod,
        }
        AppContext.getApiClient().patch('/invoices/' + this.state.invoiceId, {
            recurringInfo: data,
        }).then((r) => {
            this.state.onChange(r.attributes.recurringInfo)
            this.setState({
                info: r.attributes.recurringInfo,
                editMode: false,
                saving: false,
            })

            const isMissingCreditCard = this.state.paymentMethod === PAYMENT_TYPE.CREDIT_CARD && !this.state.defaultCreditCard
            const isMissingBankAccount = this.state.paymentMethod === PAYMENT_TYPE.BANK_TRANSFER && !this.state.defaultBankAccount

            if (this.state.capturePayment && (isMissingCreditCard || isMissingBankAccount) &&  GlobalHelper.getPaymentIntegrationPerLocation(this.props.locationId) != undefined) {
                this.setState({ showAddPaymentMethodModal: true })
            }
        })
    }

    renderText() {
        const info = this.state.info || {}
        const attr = info.attributes || {}
        const lines = []

        let icon = <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
        if (!this.state.editable) {
            icon = ''
        }
        if (attr.capturePayment && attr.sendEmail) {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="invoice.recurring.options.send_email_and_capture_payment"
                    defaultMessage="Automatically send emails and capture payments"
                />
                {icon}
            </p>)
        } else if (attr.capturePayment && !attr.sendEmail) {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="invoice.recurring.options.capture_payment_without_email"
                    defaultMessage="Automatically capture payment without sending email"
                />
                {icon}
            </p>)
        } else if (!attr.capturePayment && attr.sendEmail) {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="invoice.recurring.options.send_email_only"
                    defaultMessage="Automatically send emails"
                />
                {icon}
            </p>)
        } else {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="invoice.recurring.options.no_payment_and_no_email"
                    defaultMessage="Only create invoices"
                />
                {icon}
            </p>)
        }

        if (attr.sendEmail) {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="invoice.recurring.options.send_invoice_in_advance"
                    defaultMessage="Send invoice {count, plural, =0 {on due date} one {# day in advance} other {# days in advance}}"
                    values={{
                        count: attr.createDaysInAdvance
                    }}
                />
                {icon}
            </p>)
        } else {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="invoice.recurring.options.create_invoice_in_advance"
                    defaultMessage="{count, plural, =0 {Create invoice on due date} one {Create invoice # day in advance} other {Create invoice # days in advance}}"
                    values={{
                        count: attr.createDaysInAdvance
                    }}
                />
                {icon}
            </p>)
        }

        return lines
    }

    handleUpdateOptions(options) {
        this.setState({
            sendEmail: options.sendEmail,
            capturePayment: options.capturePayment,
            paymentMethod: options.paymentMethod,
            createDaysInAdvance: options.day,
        })
    }

    handleOpenModal() {
        this.setState({ showAddPaymentMethodModal: true })
    }

    handleCloseModal() {
        this.setState({ showAddPaymentMethodModal: false })
    }

    handleSubmitModal() {
        this.state.refreshInvoice()
    }

    render() {
        if (!this.state.info) {
            return ''
        }

        return (
            <>
                {this.state.editable ? (
                    <span>
                        <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                            {this.renderText()}
                        </a>
                        <RecurringOptionsDropdown
                            show={this.state.editMode}
                            loading={this.state.saving}
                            documentType={PROPOSAL_TYPE.INVOICE}
                            options={{
                                sendEmail: this.state.sendEmail,
                                capturePayment: this.state.capturePayment,
                                paymentMethod: this.state.paymentMethod,
                                day: this.state.createDaysInAdvance,
                            }}
                            onUpdate={this.handleUpdateOptions}
                            onClose={this.triggerEdit}
                            onSave={this.save}
                        />
                    </span>
                ) : (
                    this.renderText()
                )}
                { this.state.isCardLoading ? <LoadingSpinner /> :
                    <PaymentMethodLabel
                        show={this.state.capturePayment && this.state.hasIntegratedPayment}
                        showModal={this.state.showAddPaymentMethodModal}
                        disabled={this.state.editMode}
                        paymentMethod={this.state.paymentMethod}
                        creditCard={this.state.defaultCreditCard?.attributes.card ?? null}
                        bankAccount={this.state.defaultBankAccount?.attributes.bankAccount ?? null}
                        contactId={this.state.contactId}
                        onOpenModal={this.handleOpenModal}
                        onCloseModal={this.handleCloseModal}
                        onSubmitModal={this.handleSubmitModal}
                        locationId={this.props.locationId}
                />
                }
            </>
        )
    }

}

export default RecurringInvoiceOptions





// WEBPACK FOOTER //
// ./src/invoice/recurring/options.component.jsx